import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  BarChart,
  CartesianGrid,
  Bar,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { startOfHour, parseISO, format, eachHourOfInterval, startOfDay, endOfDay } from "date-fns";
import { i18n } from "../../translate/i18n";
import Title from "./Title";
import useTickets from "../../hooks/useTickets";

const Chart = ({ whatsappId, userId, selectedDate }) => {
  const theme = useTheme();

  const dateRef = useRef(selectedDate || new Date().toISOString());

  // Actualizar ref cuando cambia selectedDate
  const dateToUse = selectedDate || dateRef.current;

  const { tickets } = useTickets({
    date: dateToUse,
    whatsappId: whatsappId || "",
    userId: userId || "",
  });

  const buildEmptyHours = () => {
    const hours = [];
    for (let h = 7; h <= 21; h++) {
      hours.push({ time: `${String(h).padStart(2, "0")}:00`, amount: 0 });
    }
    return hours;
  };

  const [chartData, setChartData] = useState(buildEmptyHours());

  useEffect(() => {
    const empty = buildEmptyHours();
    tickets.forEach(ticket => {
      const hour = format(startOfHour(parseISO(ticket.createdAt)), "HH:mm");
      const slot = empty.find(e => e.time === hour);
      if (slot) slot.amount++;
    });
    setChartData([...empty]);
  }, [tickets]);

  return (
    <React.Fragment>
      <Title>
        {`${i18n.t("dashboard.charts.perDay.title")}${tickets.length}`}
      </Title>
      <ResponsiveContainer>
        <BarChart
          data={chartData}
          barSize={32}
          margin={{ top: 16, right: 16, bottom: 0, left: 24 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" stroke={theme.palette.text.secondary} tick={{ fontSize: 11 }} />
          <YAxis
            type="number"
            allowDecimals={false}
            stroke={theme.palette.text.secondary}
          >
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.primary }}
            >
              Tickets
            </Label>
          </YAxis>
          <Tooltip
            contentStyle={{
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 4,
            }}
            formatter={(value) => [value, "Tickets"]}
          />
          <Bar dataKey="amount" fill={theme.palette.primary.main} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Chart;